import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";


const JavaScriptAJAX= () => {
  const [language, changeLanguage] = useState("javascript");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code1 = (
  'text',
  `
  const xhr = new XMLHttpRequest();

  xhr.onreadystatechange = function() {
      if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
              console.log(xhr.responseText); // Response from the server
          } else {
              console.error('Error:', xhr.status);
          }
      }
  };

  xhr.open('GET', 'https://catfact.ninja/breeds', true); // true for asynchronous
  xhr.send();

  `
  );

  const code2 = (
  'text',
  `
  fetch("https://catfact.ninja/breeds", {
          method: 'GET',
        })
          .then(response => response.json())
          .then(responseJson => {
             console.warn(responseJson);
          })
          .catch(error => {
            {
              alert(error)
            }
        }),
  `
  );

  const code3 = (
  'text',
  `
  axios.get('https://catfact.ninja/breeds')
  .then(response => {
    console.log(response.data); // Process the response data
  })
  .catch(error => {
    console.error('Axios error:', error);
  });
  `
  );

  const code4 = (
  'text',
  `
  const postData = {
  username: 'john_doe',
  password: 'secret123'
};

// Make a POST request
axios.post('https://api.example.com/login', postData)
  .then(response => {
    console.log(response.data); // Process the response data
  })
  .catch(error => {
    console.error('Axios error:', error);
  });
  `
  );

  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

    <h3><strong>AJAX</strong></h3>
      <p>AJAX (Asynchronous JavaScript and XML) is a technique used in web development to send and receive data from a server asynchronously without having to reload the entire webpage. It allows for dynamic updating of web content and enhanced user interaction.</p>

      <div className="alert alert-secondary mt-3" role="alert">
      <h3 className="mt-3"><strong>XMLHttpRequest (XHR):</strong></h3>

        <CopyBlock
        language={language}
        text={code1}
        showLineNumbers={lineNumbers}
        theme={dracula}
        wrapLines={true}
        codeBlock
        />
      </div>

      <div class="alert alert-secondary" role="alert">
      <h3><strong>CRUD Operations</strong></h3>
      <ol class="list-group list-group-numbered mb-4">
      <li class="list-group-item"><strong>Create (C):</strong> The Create operation involves adding new data records to a database. This typically involves inserting a new row into a database table or creating a new document in a NoSQL database. In CRUD applications, creating data usually involves collecting information from the user through a form or input fields and then saving that information to the database.</li>
      <li class="list-group-item"><strong>Read (R):</strong> The Read operation involves retrieving data records from a database. This can include retrieving a single record by its unique identifier (e.g., primary key) or querying the database to retrieve multiple records that match certain criteria. Reading data is often performed when displaying information to users in a web application or fetching data to perform further processing or analysis.</li>
      <li class="list-group-item"><strong>Update (U):</strong> The Update operation involves modifying existing data records in a database. This typically involves changing the values of one or more fields in a database record. Update operations are commonly used when users need to edit or update information that has already been saved to the database. Like creating data, updating data often involves collecting user input through forms or input fields.</li>
      <li class="list-group-item"><strong>Delete (D):</strong> The Delete operation involves removing existing data records from a database. This operation permanently deletes the data from the database, and it cannot be undone. Delete operations are used when data is no longer needed or when it needs to be removed to maintain data integrity. For example, deleting a user account or removing outdated records from a database.</li>
      </ol>
      </div>

        <div id="fetch" className="alert alert-secondary mt-3" role="alert">
        <h3><strong>Fetch API:</strong></h3>
        <p>The Fetch API is a modern JavaScript interface for fetching resources (such as JSON data, HTML, images, etc.) asynchronously across the network. It provides a more powerful and flexible alternative to the older XMLHttpRequest (XHR) object for making HTTP requests in web applications.</p>
        <p>The Fetch API is promise-based, which means it uses Promises to handle asynchronous operations, making it easier to write cleaner and more readable code.</p>
          <CopyBlock
          language={language}
          text={code2}
          showLineNumbers={lineNumbers}
          theme={dracula}
          wrapLines={true}
          codeBlock
          />
        </div>

        <div id="fetch" className="alert alert-secondary mt-3" role="alert">
        <h3><strong>Axios:</strong></h3>
        <p>Axios is a popular JavaScript library used for making HTTP requests from web browsers and Node.js applications. It provides an easy-to-use API and supports features like Promise-based requests, request and response interception, automatic transformation of JSON data, and more.</p>
        <p>Axios simplifies the process of making HTTP requests and handling responses in JavaScript applications.</p>
          <CopyBlock
          language={language}
          text={code3}
          showLineNumbers={lineNumbers}
          theme={dracula}
          wrapLines={true}
          codeBlock
          />
        <br />
        <p>Here, we are doing the following: </p>
        <ul>
        <li>We use the axios.get() function to make a GET request to the specified URL ('https://api.example.com/data')</li>
        <li>The axios.get() function returns a Promise that resolves to a response object containing the response data.</li>
        <li>We use the then() method to handle the response asynchronously. Inside the callback function, we access the data property of the response object to process the response data.</li>
        <li>We use the catch() method to handle any errors that occur during the request.</li>
        </ul>
        <h3><strong>Axios with POST Method:</strong></h3>
        <CopyBlock
        language={language}
        text={code4}
        showLineNumbers={lineNumbers}
        theme={dracula}
        wrapLines={true}
        codeBlock
        />
        </div>

             </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptAJAX
